import { useEffect, useState } from 'preact/compat'
import { CARD_TYPES } from '../../../constants/card'
import {
  AMEX_CARD_CHECKER,
  getCleanedCardNumber,
  MAESTRO_CARD_CHECKER,
  OMNIO_CARD_CHECKER,
} from '../../../helpers/cardType.js'

export default function useCardType(cardNumber) {
  const [cardType, setCardType] = useState('')

  useEffect(() => {
    if (AMEX_CARD_CHECKER.test(getCleanedCardNumber(cardNumber))) {
      setCardType(CARD_TYPES.amex)
    } else if (MAESTRO_CARD_CHECKER.test(getCleanedCardNumber(cardNumber))) {
      setCardType(CARD_TYPES.maestro)
    } else if (OMNIO_CARD_CHECKER.test(getCleanedCardNumber(cardNumber))) {
      setCardType(CARD_TYPES.omnio)
    } else if (cardNumber) {
      // todo: checkers for other card types might be added later
      setCardType(CARD_TYPES.notDetected)
    } else {
      setCardType('')
    }
  }, [cardNumber])

  return cardType
}
